import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const DeploymentDashboard = Loader(
  lazy(() => import('src/content/dashboards/DashboardV2'))
);

const OrderDashboard = Loader(
  lazy(() => import('src/content/dashboards/OrderDashboard'))
);

const ServiceDashboard = Loader(
  lazy(() => import('src/content/dashboards/ServiceDashboard'))
);

const otherDashboards = [
  {
    path: 'deployment-dashboard',
    element: <DeploymentDashboard />
  },
  {
    path: 'order-dashboard',
    element: <OrderDashboard />
  },
  {
    path: 'service-dashboard',
    element: <ServiceDashboard />
  },
  {
    path: 'department-dashboard',
    element: <Navigate to="/reports/session-report/station-dashboard" replace />
  },
  {
    path: 'station-dashboard',
    element: <Navigate to="/reports/session-report/station-dashboard" replace />
  }
];

export default otherDashboards;
